import i18n from './i18n.js';

/** Translate outside React components (hooks, utilities). */
export function translateAdmin(
  key: string,
  options?: Record<string, unknown>,
): string {
  return i18n.t(key, { ns: 'admin', ...options });
}
